
export const API_URL = process.env.API_URL
  ? process.env.API_URL
  : "http://localhost:5183";

export const CDN_URL = process.env.CDN_URL
  ? process.env.CDN_URL
  : "http://localhost:3005";

